import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorPolicyService } from '@mri-platform/angular-error-handling';
import { ApiConfig } from '@mri-platform/shared/core';
import { saveAs } from 'file-saver';
import { Observable, tap } from 'rxjs';
import { File, FileType, UserSelection } from '../models';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfig,
    private errorPolicyService: ErrorPolicyService
  ) {}

  downloadFile(relUrl: string, fileName: string, extension?: string) {
    const url = `${this.apiConfig.url}/${relUrl}`;
    return this.download(fileName, url, extension);
  }

  downloadFileByFileName(fileName: string, extension?: string) {
    const name = fileName.split('.').slice(0, -1).join('.');
    const params = { name: fileName };
    const url = `${this.apiConfig.url}/files`;
    return this.download(name, url, extension, params);
  }

  downloadConnectionFields(fileName: string, params: { [key: string]: string }) {
    const url = `${this.apiConfig.url}/files`;
    return this.download(fileName, url, undefined, params);
  }

  downloadFileById(fileId: number, fileName: string) {
    const url = `${this.apiConfig.url}/files/downloadFileById/${fileId}`;
    return this.download(fileName, url);
  }

  downloadAlterValueFile(fileId?: number, fileName?: string) {
    if (fileId && fileName) return this.downloadFileById(fileId, fileName);
    const url = `${this.apiConfig.url}/files/downloadAlterValueSampleFile`;
    return this.download('AlterMappingSampleFile', url);
  }

  updateFile(fileId: number, body: UserSelection): Observable<File> {
    const url = `${this.apiConfig.url}/files/${fileId}`;
    return this.http.put<File>(url, body).pipe(this.errorPolicyService.catchHandleReplace(null as never));
  }

  findFileType(destination: string) {
    return destination ? destination.split('.').pop() : FileType.Csv;
  }

  private download(fileName: string, url: string, extension?: string, params?: { [key: string]: string }) {
    return this.http.get(url, { responseType: 'blob', params }).pipe(
      tap(data => this.generateFile(fileName, data, extension)),
      this.errorPolicyService.catchHandle()
    );
  }

  private generateFile(fileName: string, data: Blob, extension: string = FileType.Csv) {
    const blob = new Blob([data], { type: `text/${extension}` });
    saveAs(blob, `${fileName}.${extension}`);
  }
}
